import { Switch } from "react-router-dom";

import AppModalRoute from "./AppModalRoute";
import AppRoute from "./AppRoute";
import { RouteConfig } from "./routes";

interface Props {
  routes: RouteConfig[];
}

/**
 * Renders the routes for given configuration
 * @param routes - array of routes configurations
 */
export const AppRouter = ({ routes }: Props) => {
  const regularRoutes = routes.filter((routeConfig) => !routeConfig.modal);
  const modalRoutes = routes.filter((routeConfig) => !!routeConfig.modal);

  return (
    <>
      <Switch>
        {regularRoutes.map((routeConfig: RouteConfig) => (
          <AppRoute key={routeConfig.path?.toString()} {...routeConfig} />
        ))}
      </Switch>
      {modalRoutes.map((routeConfig) => (
        <AppModalRoute key={routeConfig.path?.toString()} {...routeConfig} />
      ))}
    </>
  );
};

export default AppRouter;
